import { render, staticRenderFns } from "./RequirementItem.vue?vue&type=template&id=79f7cf7e&scoped=true"
import script from "./RequirementItem.vue?vue&type=script&lang=js"
export * from "./RequirementItem.vue?vue&type=script&lang=js"
import style0 from "./RequirementItem.vue?vue&type=style&index=0&id=79f7cf7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79f7cf7e",
  null
  
)

export default component.exports